import { useQuery } from "@tanstack/react-query";
import ApiClient from "../../../api/ApiClient";
import { ListOption } from "../data/ListOption";

async function get(categoryIds: number[]): Promise<ListOption[]> {
    const response = await ApiClient({ url: `categories/getListOptions`, method: "POST", data: { categoryIds: categoryIds } });

    if (response.status === 200) {
        return response.data;
    }

    throw new Error(response.data);
}

export function useGetListOptionQuery(categoryIds: number[], enable: boolean = true) {
    return useQuery<ListOption[]>({
        queryKey: ["get-option-list"],
        queryFn: () => get(categoryIds),
        refetchOnWindowFocus: false,
        enabled: enable
    });
}